var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H21V18.9H7V21ZM13.895 16.59L19.425 11.095L17.955 9.625L14.98 12.565V5.6H12.88V12.565L9.905 9.625L8.435 11.095L13.895 16.59ZM14 28C12.0867 28 10.2783 27.6325 8.575 26.8975C6.87167 26.1625 5.38417 25.1592 4.1125 23.8875C2.84083 22.6158 1.8375 21.1283 1.1025 19.425C0.3675 17.7217 0 15.9133 0 14C0 12.0633 0.3675 10.2433 1.1025 8.54C1.8375 6.83667 2.84083 5.355 4.1125 4.095C5.38417 2.835 6.87167 1.8375 8.575 1.1025C10.2783 0.3675 12.0867 0 14 0C15.9367 0 17.7567 0.3675 19.46 1.1025C21.1633 1.8375 22.645 2.835 23.905 4.095C25.165 5.355 26.1625 6.83667 26.8975 8.54C27.6325 10.2433 28 12.0633 28 14C28 15.9133 27.6325 17.7217 26.8975 19.425C26.1625 21.1283 25.165 22.6158 23.905 23.8875C22.645 25.1592 21.1633 26.1625 19.46 26.8975C17.7567 27.6325 15.9367 28 14 28ZM14 25.9C17.3133 25.9 20.125 24.7392 22.435 22.4175C24.745 20.0958 25.9 17.29 25.9 14C25.9 10.6867 24.745 7.875 22.435 5.565C20.125 3.255 17.3133 2.1 14 2.1C10.71 2.1 7.90417 3.255 5.5825 5.565C3.26083 7.875 2.1 10.6867 2.1 14C2.1 17.29 3.26083 20.0958 5.5825 22.4175C7.90417 24.7392 10.71 25.9 14 25.9Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.bbe45cf60a0a675f26ac78d04fe0b19e.svg";
export { ForwardRef as ReactComponent };